import React from "react";
import { ServiceRequestClientEmailBadge } from "./adminRequestClientEmailBadge";
import { ServiceRequestEmailStageBadge } from "./adminRequestEmailStageBadge";

/**
 * Service requests table cell: **Stage** (Not sent / Sent / Reply) + **Offer** (AI stance on latest inbound).
 */
export function ServiceRequestClientEmailColumn({ row }) {
  return (
    <div className="admin-dash__client-email-col">
      <div className="admin-dash__client-email-cell-row">
        <span className="admin-dash__client-email-cell-row__label">Stage</span>
        <div className="admin-dash__client-email-cell-row__value">
          <ServiceRequestEmailStageBadge row={row} />
        </div>
      </div>
      <div className="admin-dash__client-email-cell-row">
        <span className="admin-dash__client-email-cell-row__label">Offer</span>
        <div className="admin-dash__client-email-cell-row__value">
          <ServiceRequestClientEmailBadge row={row} />
        </div>
      </div>
    </div>
  );
}
